module.exports = __webpack_public_path__ + "static/media/seakeeper-logo-only.596f98f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global/seakeeper-logo-only.svg
// module id = 21
// module chunks = 0